import { SubscriptionStatus } from '../../../types/entities'

export const subscriptionStatusLabel = (status: SubscriptionStatus): string => {
  const labels: Record<SubscriptionStatus, string> = {
    active: 'Ativa',
    cancelled: 'Cancelada',
    overdue: 'Em Atraso',
  }
  return labels[status]
}

export const subscriptionStatusSeverity = (status: SubscriptionStatus): 'success' | 'danger' | 'warning' => {
  const map: Record<SubscriptionStatus, 'success' | 'danger' | 'warning'> = {
    active: 'success',
    cancelled: 'danger',
    overdue: 'warning',
  }
  return map[status]
}
